@use 'sass:color';
@use "../../scss/util";

.splash {
    @include util.fbox();
    max-width: 960;
    margin: 0 auto;

    &Content {
        flex-basis: 100%;
        text-align: center;
        
        @include util.mq(util.$md) {
            flex-basis: 50%;
            text-align: left;
        }
    }

    &PhotoBox {
        display: none;
        @include util.mq(util.$md) { 
            display: flex;
            align-items: flex-end;
            flex-basis: 50%;
        }
    }

    
    &Content {
        margin: 1em;
        color: white;
        position: relative;
        z-index:1;

        &::before{
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: -1;
            opacity: .33;
            background: url("../../images/splash-heart.png") center bottom no-repeat;
            background-size: contain;

            @include util.mq(util.$md) { display: none }
        }
        
        .title { 
            @include util.font-body(700);
            line-height: 1.4em;
            font-size: 2em;
            letter-spacing: 1px;
        }
        
        p { 
            @include util.font-body(200);
            line-height: 1.5em;
            font-size: 1.25em;
            margin: 2em 0;
            font-weight: 500;
        }

        &Book {
            @include util.button(util.$eGold, util.$eBlueDark);
    
            &:hover {
                background: color.scale(util.$eGold, $lightness: -20%);
                transition: background .3s ease-in-out;
            }
        }
    }
    
    &PhotoBox {        
        .splashHeart {
            max-width: 100%;
            height: auto;
        }
    }
}